/**
 * How many digits are in the signup verification code.
 *
 * 🚨 THIS MUST MATCH A NUMBER THAT LIVES OUTSIDE THIS REPO.
 *
 * Supabase Dashboard → Authentication → Sign In / Providers → Email →
 * **Email OTP length**. There is no `supabase/config.toml` here, so nothing in
 * git records that value and no test can check it: if the two disagree, the
 * boxes on screen can never hold the code that was emailed, `verifyOtp` is
 * never called, and the owner sits typing into a form that cannot accept what
 * it asked for. Nothing errors.
 *
 * As of 2026-09-14 the live MUCKA PRO project is set to **8**, which is
 * Supabase's own default — not a decision anybody made. The first cut of this
 * feature hard-coded six, because six is what Mucka's WhatsApp pairing uses and
 * nobody had read the dashboard. It would have shipped a screen that could not
 * be completed.
 *
 * Change one, change the other, in the same sitting.
 *
 * The companion value is **Email OTP expiration**, 3600 seconds on prod — one
 * hour, not the 24 hours the email template's footer still claims.
 */
export const SIGNUP_CODE_LENGTH = 8;

/** True when `code` is exactly the digits Supabase will have sent. */
export function isCompleteSignupCode(code: string): boolean {
  return new RegExp(`^\\d{${SIGNUP_CODE_LENGTH}}$`).test(code);
}
